export default __webpack_public_path__ + "images/27b1d0f22dea3548bcf3cf0201bcde95-PyxHealthTransparentLogo.png";